import {useCallback, useInsertionEffect, useRef} from 'react';

export function useNonReactiveCallback<T extends (...args: any[]) => any>(callback: T | undefined): T {
    const ref = useRef(callback);
    useInsertionEffect(() => {
        ref.current = callback;
    }, [callback]);
    return useCallback(((...args) => ref.current?.(...args)) as T, []);
}
/**
 * @deprecated might work unexpectedly with suspense and `use` in react 19;
 * @see useNonReactiveCallback
 */

export function useLatestCallback<T extends (...args: any[]) => any>(callback: T | undefined): T {
    const ref = useRef(callback);
    ref.current = callback;
    return useCallback(((...args) => ref.current?.(...args)) as T, []);
}
